import React from "react";

import { ZodSchema } from "zod";

export const withZodValidationOnChange = <S extends ZodSchema>(
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>,
  schema: S,
) => {
  return (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const result = schema.safeParse(event.target.value);

    if (result.success) {
      onChange(event);
    }
  };
};
